import React from "react";
// eslint-disable-next-line import/prefer-default-export
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SpeechBubbleImage() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "220",
    height: "102",
    fill: "none",
    viewBox: "0 0 220 102",
    children: [/*#__PURE__*/_jsx("path", {
      className: "illustrationFill",
      d: "M171 46.269c0 15.935-9.654 29.999-24.371 38.378l.088 1.433h48.246a7.107 7.107 0 005.051-12.107 7.081 7.081 0 00-5.051-2.109h-6.094a7.107 7.107 0 01-7.107-7.108 7.106 7.106 0 017.107-7.108h19.293a7.109 7.109 0 100-14.216h-22.338a7.108 7.108 0 000-14.216h-18.709c2.508 5.28 3.885 11.033 3.885 17.053zM73.55 15H62.958a7.11 7.11 0 00-.072 14.216H22.34a7.108 7.108 0 100 14.216h25.385a7.11 7.11 0 110 14.216H7.107a7.108 7.108 0 000 14.216H46.71a7.108 7.108 0 000 14.216h39.34C69.836 77.934 59 63.152 59 46.27c0-6.02 1.377-11.773 3.885-17.053C65.393 23.936 69.03 19.129 73.55 15z"
    }), /*#__PURE__*/_jsx("path", {
      className: "illustrationFill",
      d: "M205.117 78.972a7.108 7.108 0 1014.216 0 7.108 7.108 0 00-14.216 0z"
    }), /*#__PURE__*/_jsx("path", {
      className: "illustrationStroke",
      fillRule: "evenodd",
      d: "M144.556 83.757l1.084-.617C159.868 75.04 169 61.572 169 46.5 169 22.255 145.188 2 115 2S61 22.255 61 46.5 84.813 91 115 91c5.023 0 9.883-.566 14.492-1.622l.837-.192 15.183 10.062-.956-15.491zm-14.617 7.57A66.848 66.848 0 01115 93c-30.928 0-56-20.819-56-46.5S84.072 0 115 0s56 20.819 56 46.5c0 15.936-9.654 30-24.371 38.378l.88 14.246c.101 1.649-1.725 2.703-3.101 1.791l-14.469-9.588z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      className: "illustrationStroke",
      fillRule: "evenodd",
      d: "M74.293 30.918a1 1 0 01.35 1.37 33.882 33.882 0 00-2.318 4.696 1 1 0 01-1.857-.742 35.894 35.894 0 012.455-4.973 1 1 0 011.37-.35zM93.33 14.86a1 1 0 01-.473 1.333c-6.522 3.113-12.009 7.507-15.963 12.745a1 1 0 11-1.596-1.205c4.164-5.517 9.913-10.107 16.698-13.345a1 1 0 011.333.472z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      className: "illustrationFill",
      fillRule: "evenodd",
      d: "M94.434 52.787a6.093 6.093 0 110-12.185 6.093 6.093 0 010 12.185zm19.294 0a6.093 6.093 0 110-12.186 6.093 6.093 0 010 12.186zm19.293 0a6.093 6.093 0 110-12.186 6.093 6.093 0 010 12.186z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      className: "illustrationStroke",
      fillRule: "evenodd",
      d: "M94.434 41.602a5.093 5.093 0 100 10.185 5.093 5.093 0 000-10.185zm-7.092 5.092a7.093 7.093 0 1114.185 0 7.093 7.093 0 01-14.185 0zm26.386-5.092a5.093 5.093 0 100 10.185 5.093 5.093 0 000-10.185zm-7.093 5.092a7.092 7.092 0 1114.185 0 7.092 7.092 0 01-14.185 0zm26.386-5.092a5.093 5.093 0 100 10.185 5.093 5.093 0 000-10.185zm-7.093 5.092a7.093 7.093 0 1114.186.001 7.093 7.093 0 01-14.186 0z",
      clipRule: "evenodd"
    })]
  });
}